import dataConfig from './ajax_config.json'

// function setSendContent(type, addressName, params, header, id) {
//   var url
//   if (id) {
//     url = dataConfig.prefix + dataConfig.urls[addressName].url.replace(new RegExp('{id}', 'g'), id) + dataConfig.suffix
//   } else if (type === 'POST' && (addressName === 'getPublicKey' || addressName === 'login')) {
//     url = dataConfig.prefix + dataConfig.urls[addressName].url
//   } else {
//     url = dataConfig.prefix + dataConfig.urls[addressName].url + dataConfig.suffix
//   }
//
//   if (type === 'GET') {
//     return {
//       method: type,
//       params: params,
//       url: url
//     }
//   }
//   if (header === true) {
//     return {
//       method: type,
//       url: url,
//       body: params,
// //      params: params,
//       emulateJSON: true,
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
//         'Accept': 'application/json, text/javascript, */*; q=0.01',
//         'X-Requested-With': 'XMLHttpRequest'
//       }
//     }
//   } else {
//     return {
//       method: type,
//       url: url,
//       emulateJSON: false,
//       body: params
//     }
//   }
// }

export default class ajaxFactory {
  static get (addressName) {
    return dataConfig.prefix + dataConfig.urls[addressName].url + dataConfig.suffix
  }
  // static get(addressName, params, header) {
  //   return setSendContent('GET', addressName, params, header)
  // }
  //
  // static post(addressName, params, header) {
  //   return setSendContent('POST', addressName, params, header)
  // }
  //
  // static getById(addressName, params, header, id) {
  //   return setSendContent('GET', addressName, params, header, id)
  // }
  //
  // static postById(addressName, params, header, id) {
  //   return setSendContent('POST', addressName, params, header, id)
  // }
  //
  // static getPath(addressName) {
  //   return dataConfig.prefix + dataConfig.urls[addressName].url + dataConfig.suffix
  // }
  //
  // static getSignature(addressName, key) {
  //   return dataConfig.prefix + dataConfig.urls[addressName].url + dataConfig.suffix + '?key=' + key
  // }
};



// WEBPACK FOOTER //
// ./src/config/ajax_factory.js